import { toastr } from 'react-redux-toastr';
import { DownloadType } from './types';
import { downloadBlob } from './fileHelpers';
import { instance } from '@/config/axios';
import { urls } from '@/config/urls';
import { i18next, errorConfig } from '@/config/i18n';

const MIME_TYPES: Record<string, string> = {
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  json: 'application/json',
};

const EXTENSIONS: Record<string, string> = {
  excel: 'xlsx',
  json: 'json',
};

const downloadOptimizationFile = async (
  optimizationId: string,
  type: Exclude<DownloadType, 'pdf'>
) => {
  const { data } = await instance.get(
    `${urls.server.process.processes}${optimizationId}/`,
    {
      headers: { Accept: MIME_TYPES[type] },
      responseType: 'blob',
    }
  );

  downloadBlob(data, `optimization-${optimizationId}.${EXTENSIONS[type]}`);
};

export const handleDownload = async (
  type: DownloadType,
  optimizationId: string
) => {
  if (type === 'pdf') {
    return; // Handled by UI
  }

  try {
    await downloadOptimizationFile(optimizationId, type);
  } catch (error) {
    console.error(`Failed to download ${type}:`, error);
    toastr.error(
      i18next.t('common:states.errorTitle'),
      i18next.t('err:occurred'),
      errorConfig
    );
  }
};
